<template>
  <div v-loading="loading" element-loading-text="数据加载中..." style="height: 100%;width: 100%">
    <div ref="total_height" style="width:100%;height: 100%;overflow-x: hidden;overflow-y: hidden">
      <!--        时间-->
      <div style="height: 100%;width: 100%;overflow-x: auto;overflow-y: hidden">
        <div style="display: flex;margin-top: 5px;text-align: center;height: 46px;">
          <div v-for="calendar in dataList" style="width:100%;" :key="calendar">
            <div style="margin-left: 3px"  class="border color">
              <div>{{ calendar.time }}</div>
              <div>{{ calendar.week }}</div>
            </div>
          </div>
        </div>

        <!--数据-->
        <div style="height: 87%;overflow-y: auto;overflow-x: hidden;width: 100%;display: flex;" ref="dynamicDiv" class="scrollable-container">
          <div class="total_style" id="total" v-for="item in dataList" style="width: 100%;" :key="item">
            <div v-if="!item.line_bool" :class="!item.line_bool?'prompt data_style1':''" :style="maxHeight">产线未开</div>
            <div v-if="item.line_bool" class="data_style">
              <div v-for="lineCnt in item.line_cnt" :key="lineCnt" class="data_style2" >
                <div class="data_style3">
                  <span v-if="lineCnt.dayShiftCnt == 'powder'" style="background-color: burlywood" class="data_style4">&nbsp;粉体&nbsp;</span>
                  <span v-if="lineCnt.dayShiftCnt == 'liquid'" style="background-color: #0486fe" class="data_style4">&nbsp;液体&nbsp;</span>
                  <span v-if="lineCnt.dayShiftCnt == 'pretreatment'" style="background-color: #2bd82f"
                        class="data_style4">&nbsp;前处理&nbsp;</span>
                  <span v-if="lineCnt.nightShiftCnt == 'powder'" style="background-color: burlywood"
                        class="data_style4_1">&nbsp;粉体&nbsp;</span>
                  <span v-if="lineCnt.nightShiftCnt == 'liquid'" style="background-color: #0486fe"
                        class="data_style4_1">&nbsp;液体&nbsp;</span>
                  <span v-if="lineCnt.nightShiftCnt == 'pretreatment'" style="background-color: #2bd82f"
                        class="data_style4_1">&nbsp;前处理&nbsp;</span>
                </div>
                <div :class="lineCnt.class_name" :style="dayMaxLineHeight[lineCnt.class_name]">
                  <div v-if="lineCnt.remark != '' && lineCnt.remark != undefined" style="margin-bottom: 2px;"
                       class="item">{{ lineCnt.remark }}
                  </div>
                  <draggable :style="lineCnt.height" :class="lineCnt.class_line_name" :list="lineCnt.lineData"
                             ghost-class="ghost" handle=".move" chosen-class="chosenClass" animation="300"
                             :sort="true" group="group">
                    <template #item="{ element }">
                      <div class="item">
                        <el-row style="border-bottom: #0478e4 2px solid">
                          <el-col :span="24">
                            <span>{{ element.wujian_short_name }}&nbsp;-&nbsp;</span>
                            <span>{{ element.floor }}F&nbsp;-&nbsp;</span>
                            <span>{{ paint_type_name[element.paint_type] }}</span>
                          </el-col>
                        </el-row>

                        <el-row
                            :style="lineCnt.dayShiftCnt == 'powder' || lineCnt.dayShiftCnt == 'liquid' ||  lineCnt.nightShiftCnt == 'powder' || lineCnt.nightShiftCnt == 'liquid'?'border-bottom: #0478e4 2px solid':''">
                          <el-col v-for="batchNo in element.batchData" :key="batchNo" :span="12">
                            <div>{{ batchNo }}</div>
                          </el-col>
                        </el-row>
                        <el-row
                            v-if="lineCnt.dayShiftCnt == 'powder' || lineCnt.dayShiftCnt == 'liquid' ||  lineCnt.nightShiftCnt == 'powder' || lineCnt.nightShiftCnt == 'liquid'">
                          <el-col v-for="color in element.colorData" :key="color" :span="12">
                            <div>{{ color }}</div>
                          </el-col>
                        </el-row>
                      </div>
                    </template>
                  </draggable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import draggable from "vuedraggable";
import moment from "moment";

export default {
  name: "ZhiZaoKanBan3",
  components: {draggable},
  data() {
    return {
      assemblyEndTime: '',
      batchNoList: [],//修改前的批号数据
      state: {
        dataList: [],
      },
      dataList:[],
      dataListIntervalId: null,
      index: 0,
      startTime: '',
      endTime: '',
      week: [], //时间组件数据
      weekList: [], //一个星期的时间
      splitBatchItemBool: false, //控制物料详情页面
      formWujianData: {},
      lineBool: false,//false表示白班 true表示夜班
      loading: false,
      maxHeight: "",//获取页面的最大高度
      height:0,
      dayMaxLineHeight:{},
      paint_type_name: {
        'ft': '粉体',
        'fs': '液体',
        'acl': '共通'
      },
      classNameList: ['pretreatment','powder','liquid'],
    }
  }, methods: {
    async getCalendarLineDataAll(startTime, endTime, weekList) {
      this.loading = true;
      let params = {startTime: startTime, endTime: endTime, weekList: weekList}
      this.$axios.post('mfg/paintingProduction/getCalendarLineDataAll', params).then(response => {
        let res = response.data
        if (res.code !== 0) {
          this.loading = false;
          return this.$message.error(res.message);
        }

        this.state.dataList = res.data;
        //初始7条
        this.dataList = this.state.dataList.slice(this.index, this.index + 7);
        this.index = 7;
        this.maxHeight = '';
        setTimeout(async () => {
          await this.getMaxHeight();
          await this.scrollToBottom();
        }, 200)
        this.loading = false;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
        this.loading = false;
      })
    },
    // 获取本周开始结束时间
    getCurrWeekDays() {
      let obj = {
        startTime: '',
        endTime: ''
      }

      let endDate = new Date(this.assemblyEndTime); // 结束日期
      obj.startTime = moment(moment().week(moment().week()).startOf('week').add(1, 'days').valueOf()).format('YYYY-MM-DD');
      obj.endTime = moment(endDate.valueOf()).format('YYYY-MM-DD');
      return obj
    },
    //处理时间
    async formatTime(startTime, endTime) {
      this.startTime = startTime;
      this.endTime = endTime;
      this.week = [];
      this.weekList = [];
      let startDate = moment(startTime).add(-1, 'days');
      let endDate = moment(endTime);
      let weeks = ["日","一","二","三","四","五","六"]
      while (startDate.isBefore(endDate)) {
        startDate.add(1, 'days');
        let date = moment(startDate).format('YYYY-MM-DD')
        let item = {};
        item.time = moment(date).format('MM') + "月" + moment(date).format('DD') + "日";
        item.week = "(" + weeks[moment(date).day()] + ")";
        this.weekList.push(item);
      }

      this.week.push(moment(startTime).format('MM') + "-" + moment(startTime).format('DD'));
      this.week.push(moment(endTime).format('MM') + "-" + moment(endTime).format('DD'));
      await this.getCalendarLineDataAll(startTime, endTime, this.weekList)
    },
    async getAssemblyEndTime() {
      let startTime = moment(moment().week(moment().week()).startOf('week').add(1, 'days').valueOf()).format('YYYY-MM-DD');
      let endTime = moment(moment().week(moment().week()).endOf('week').add(8, 'days').valueOf()).format('YYYY-MM-DD');
      let params = {startTime: startTime, endTime: endTime};
      this.$axios.post('mfg/paintingProduction/getAssemblyEndTime', params).then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error("组立最后排产时间为空");
        }

        this.assemblyEndTime = res.data;
        let obj = this.getCurrWeekDays();
        this.formatTime(obj.startTime, obj.endTime);
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
        this.loading = false;
      })
    },
    async getMaxHeight() {
      for (let value of this.classNameList) {
        let name = "day_class_" + value;
        //白
        var widthBox = document.getElementsByClassName("day_class_" + value + "");
        if (widthBox != undefined && widthBox.length > 0) {
          let h_max = 0;
          for (let i = 0; i < widthBox.length; i++) {
            if (h_max < widthBox[i].clientHeight) {
              h_max = widthBox[i].clientHeight;
            }
          }
          this.dayMaxLineHeight[name] = "height: " + h_max + "px;";
        }
      }

      const myDiv = document.getElementById('total');
      const offsetHeight = myDiv.offsetHeight;
      this.maxHeight = "height: " + (offsetHeight - 23) + "px;";
    },
    async scrollToBottom() {
      let isAutoScrolling = true;
      // if (this.intervalId) {
      //   // 如果已经在滚动，则不再执行
      //   return;
      // }
      if (this.$refs.dynamicDiv.scrollHeight - this.$refs.dynamicDiv.offsetHeight > 0) {
        this.height = this.$refs.dynamicDiv.scrollHeight - this.$refs.dynamicDiv.offsetHeight;
      }
      let cnt = -60;
      this.intervalId = setInterval(() => {
        const container = this.$el.querySelector('.scrollable-container');
        if (container && isAutoScrolling) {
          cnt += 1; // 每次滚动1px
        }

        if (container && isAutoScrolling && cnt >= 0) {
          container.scrollTop += 1; // 每次滚动1px
        }

        if (container.scrollTop >= (this.height - 1) && isAutoScrolling) {
          clearInterval(this.intervalId)
          setTimeout( async () => {
            this.dayMaxLineHeight = {};
            this.dataList = [];
            setTimeout( async () => {
              this.dataList = this.state.dataList.slice(this.index, this.index + 7);
              this.index += 7;
              if (this.index >= this.state.dataList.length) {
                this.index = 0; // 循环到数据末尾时重置索引
              }
              cnt = -60;
              container.scrollTop = 0;
              //await this.getMaxHeight();
              await this.scrollToBottom();
              isAutoScrolling = true;
            }, 400);
          }, 10000);
        }

      }, 70); // 每0.06秒滚动一次
      // 监听鼠标滚动事件，暂停自动滚动
      window.addEventListener('wheel', () => {
        isAutoScrolling = !isAutoScrolling;
      });

      // 监听鼠标移动事件，暂停自动滚动
      window.addEventListener('mousemove', () => {
        isAutoScrolling = !isAutoScrolling;
      });
    },
    stopToBottom(){
      clearInterval(this.intervalId)
    }
  }, created() {
    this.getAssemblyEndTime();
  },unmounted() {
    this.stopToBottom();
  }
}
</script>

<style scoped>
.border {
  border: rgb(216, 220, 230) 1px solid;
}

.color {
  background-color: #e7e7e7;
}

.center {
  text-align: center;
  line-height: 32px;
}

.cursor {
  cursor: pointer;
}

/*一下是拖拽样式*/
.item {
  margin-bottom: 2px;
  border: solid 2px #0478e4;
  font-size: 14px;
  color: black;
  height: auto;
  text-align: center;
  background-color: whitesmoke;
}

.is_other_wujian_style {
  border: solid 2px #8a9197 !important;
  font-size: 14px;
  color: black;
  margin-top: 3px;
  height: 100%;
  text-align: center;
  background-color: whitesmoke;
}

.item1 {
  border-top: dashed 1px #a9aeb7 !important;
  font-size: 14px;
  color: black;
  text-align: center;
  background-color: whitesmoke;
}

.item2 {
  border: solid 2px #0478e4 !important;
  font-size: 6px;
  color: black;
  margin-top: 3px;
  height: 100%;
  text-align: center;
  background-color: #e7e7e7;
}

.item2:hover {
  background-color: whitesmoke;
}

.chosenClass {
  font-size: 13px;
  font-weight: bold;
}

/*button样式*/
.button {
  color: white;
  border-radius: 5px 5px 0 0;
  width: 100%;
  margin-top: 5px;
}

/*div样式*/
.week {
  border: #909399 0 solid;
  background-color: white;
  color: rgb(4, 134, 254);
}

.total_style {
  align-items: center;
  margin-left: 3px;
}

.data_style {
  width: 100%;
  height: auto;
}

.data_style1 {
  width: 100%;
  height: auto;
  background-color: #e7e7e7;
  margin-top: 5px;
  border: rgb(216, 220, 230) 2px solid;
}

.data_style2 {
  margin-top: 5px;
  border: rgb(216, 220, 230) 2px solid;
}

.data_style3 {
  width: 100%;
  background-color: rgb(228, 231, 237);
  color: white;
  text-align: center;
  height: 30px;
  line-height: 30px;
}

.data_style4 {
  background-color: #0478e4;
  font-size: 14px;
}

.data_style4_1 {
  background-color: black;
  margin-left: 2px;
  font-size: 14px;
}

.scrollbar::-webkit-scrollbar {
  display: none;
}

.prompt {
  color: rgba(0, 0, 0, 0.2);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.initHeight {
  border: #d8dce6 2px solid;
  height: 50px;
}

.scrollable-container {
  overflow: auto;
  height: auto; /* 设置容器高度 */
}

/* 隐藏滚动条 */
::-webkit-scrollbar {
  width: 0;
  background: transparent; /* 使滚动条透明 */
}

</style>